module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-SemiboldCond.4f9e6e5.eot";